import template from './vault_close.html';
import controller from './vault_close.controller';
import './vault_close.scss';

let vaultCloseComponent = {
  restrict: 'E',
  template,
  controller
};

export default vaultCloseComponent;

     


// WEBPACK FOOTER //
// ./client/app/components/vault_close/vault_close.component.js